import request from '@/utils/request'

export default {
    loadCardMobile: function (certificateNo, provinceCode, cityCode, numberKeyword,linkNum) {
        return request({
            url: 'saas/loadCardMobile',
            method: 'post',
            params: {
                certificateNo: certificateNo,
                provinceCode: provinceCode,
                cityCode: cityCode,
                numberKeyword: numberKeyword,
                linkNum:linkNum,
            }
        });
    },

    orderCardMobile: function (query) {
        return request({
            url: 'saas/orderCardMobile',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                linkNum:query.linkNum,
            }
        });
    },

    orderCardHain: function (query) {
        return request({
            url: 'saas/orderCardHain',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
            }
        });
    },

    loadCardCode: function () {
        return request({
            url: 'saas/loadCardCode',
            method: 'post',
            params: {}
        });
    },

    loadCardCodeHain: function () {
        return request({
            url: 'saas/loadCardCodeHain',
            method: 'post',
            params: {}
        });
    },

    loadCardProtocol: function (provinceCode) {
        return request({
            url: 'saas/loadCardProtocol',
            method: 'post',
            params: {provinceCode: provinceCode}
        });
    },


    orderCardLtxcbk: function (query) {
        return request({
            url: 'saas/orderCardLtxcbk',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                linkNum:query.linkNum,
            }
        });
    },

    selectNumberLtQh: function (provinceCode,cityCode,searchValue) {
        return request({
            url: 'saas/selectNumberLtQh',
            method: 'post',
            params: {
                provinceCode: provinceCode,
                cityCode: cityCode,
                searchValue: searchValue
            }
        });
    },
    orderCardqckLtQh: function (query) {
        return request({
            url: 'saas/orderCardqckLtQh',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode
            }
        });
    },



    selectNumberLTZJJX: function (provinceCode,cityCode,searchValue,goodsCode) {
        return request({
            url: 'saas/selectNumberLTZJJX',
            method: 'post',
            params: {
                provinceCode: provinceCode,
                cityCode: cityCode,
                searchValue: searchValue,
                goodsCode:goodsCode
            }
        });
    },
    orderCardLTZJJX: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    selectNumberLTZJJX1: function (provinceCode,cityCode,searchValue,goodsCode) {
        return request({
            url: 'saas/selectNumberLTZJJX1',
            method: 'post',
            params: {
                provinceCode: provinceCode,
                cityCode: cityCode,
                searchValue: searchValue,
                goodsCode:goodsCode
            }
        });
    },
    orderCardLTZJJX1: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX1',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX2: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX2',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX3: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX3',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX4: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX4',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX5: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX5',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX6: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX6',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX7: function (query) {
        return request({
            url: 'saas/orderCardLTZJJX7',
            method: 'post',
            params: {
                pid: query.pid,
                address: query.address,
                area: query.area,
                certificateName: query.certificateName,
                certificateNumber: query.certificateNumber,
                goodsProvinceCode: query.sendProvinceCode,
                goodsCityCode: query.sendCityCode,
                mobilePhone: query.mobilePhone,
                name: query.certificateName,
                orderMobile: query.orderMobile,
                numberCheckCode: query.numberCheckCode,
                sendProvinceCode: query.sendProvinceCode,
                sendCityCode: query.sendCityCode,
                sendDistrictCode: query.sendDistrictCode,
                goodsCode:query.goodsCode,
                resourceId:query.resourceId,
                pageUrl:query.pageUrl,
                callbackExtInfo:query.callbackExtInfo

            }
        });
    },
    orderCardLTZJJX8: function (query) {
    return request({
        url: 'saas/orderCardLTZJJX8',
        method: 'post',
        params: {
            pid: query.pid,
            address: query.address,
            area: query.area,
            certificateName: query.certificateName,
            certificateNumber: query.certificateNumber,
            goodsProvinceCode: query.sendProvinceCode,
            goodsCityCode: query.sendCityCode,
            mobilePhone: query.mobilePhone,
            name: query.certificateName,
            orderMobile: query.orderMobile,
            numberCheckCode: query.numberCheckCode,
            sendProvinceCode: query.sendProvinceCode,
            sendCityCode: query.sendCityCode,
            sendDistrictCode: query.sendDistrictCode,
            goodsCode:query.goodsCode,
            resourceId:query.resourceId,
            pageUrl:query.pageUrl,
            callbackExtInfo:query.callbackExtInfo

        }
    });
},



}
